import React from 'react';
import { string, func, bool, oneOfType, element } from 'prop-types';
import Panel from '../Panel';
import {
  Description,
  Section,
  Option,
  OptionText,
  PleaseTick,
  Purpose,
  Error,
  SubscribeCheckboxContainer,
  CheckTickContainer,
  CheckTick,
  CheckboxContainer,
  TickSvg,
  WrapperSubscribeCheckBox,
  IconContainer,
  TopHalf,
  BottomHalf,
} from './styles';

const showSubscribeText = explainer => {
  if (explainer === true) {
    return <PleaseTick>Tick to subscribe</PleaseTick>;
  } else if (explainer === false) {
    return <PleaseTick>Untick to unsubscribe</PleaseTick>;
  }
  return null;
};
const SubscribeCheckbox = ({
  icon,
  purpose,
  name,
  status,
  explainer,
  intention,
  error,
  description,
  handleCheck,
  disabled,
  action = status,
  topHalfClickable,
  ...props
}) => (
  <SubscribeCheckboxContainer {...props}>
    <Panel type={error ? 'underPanelError' : 'container'}>
      <WrapperSubscribeCheckBox>
        {icon && (
          <IconContainer>
            <img src={icon} alt="Marketing Preferences Icon" />
          </IconContainer>
        )}
        <Section>
          <TopHalf
            {...(topHalfClickable ? { onClick: () => handleCheck({ target: { name } }) } : null)}
          >
            <Option>
              <OptionText>
                {`${intention} `}
                <Purpose>{purpose}</Purpose>
              </OptionText>
              <CheckboxContainer
                status={status}
                description={description}
                {...(topHalfClickable
                  ? null
                  : { onClick: () => handleCheck({ target: { name } }) })}
              >
                <CheckTickContainer data-checkbox={status}>
                  <TickSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0  55.626 42.139">
                    <CheckTick d="M49.889,2.852l-30.274,30.6L5.748,19.649l-2.93,2.994,16.8,16.667,33.2-33.463Z" />
                  </TickSvg>
                </CheckTickContainer>
              </CheckboxContainer>
            </Option>
            {showSubscribeText(explainer)}
          </TopHalf>
          <BottomHalf>
            {description && (
              <Description>
                <span>{description}</span>
              </Description>
            )}
          </BottomHalf>
        </Section>
      </WrapperSubscribeCheckBox>
    </Panel>
    {error && <Error>{error}</Error>}
  </SubscribeCheckboxContainer>
);

SubscribeCheckbox.propTypes = {
  icon: string,
  purpose: oneOfType([string, element]),
  status: bool.isRequired,
  topHalfClickable: bool,
  action: bool,
  handleCheck: func.isRequired,
  intention: string,
  name: string,
  error: oneOfType([string, element]),
  description: oneOfType([string, element]),
  disabled: bool,
  explainer: bool,
};

SubscribeCheckbox.defaultProps = {
  icon: '',
  intention: 'Yes, I would like to ',
  purpose: '',
  error: '',
  description: '',
  name: '',
  disabled: false,
  explainer: true,
  action: false,
  topHalfClickable: true,
};

export default SubscribeCheckbox;
